if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//Burger Menu funcionality

	// Open and Close Menu
	const btn_Menu = document.querySelectorAll(".burger-cta-js");
	const menu_Section = document.querySelector("#burger-menu-js")
	btn_Menu.forEach(cta => {
		cta.addEventListener('click', (e) => {
			e.preventDefault();
			menu_Section.classList.toggle("open");
			document.querySelector("body").classList.toggle("no-scroll");
		});
	});

	//subnavigation submenu
	const menu_Items = document.querySelectorAll("#burger-menu-js li:has(.sub-sub-menu)");
	let prevMenuItem;
	menu_Items.forEach( element => {
		const Main_Link = element.querySelector("a");
		Main_Link.addEventListener('click', (e) =>{
			e.preventDefault();
			if (prevMenuItem && prevMenuItem != e.target.nextElementSibling) prevMenuItem.classList.remove('active');
			e.target.nextElementSibling.classList.toggle("active");
			prevMenuItem = e.target.nextElementSibling;
		});
	});



	
	//burger links for valley
	const vallet_links = document.querySelectorAll("#burger-menu-js .sub-sub-menu a")
	vallet_links.forEach(link => {
		link.addEventListener('click',  (e) => {
			if (e.target.hash.length > 1) {
				document.querySelector("#burger-menu-js").classList.remove("open")
			}
		});
	})


	// LBX class overflow
	LBX._instances[0].beforeShow = (e) => {document.querySelector("body").classList.add("no-scroll")};
	LBX._instances[0].beforeClose = (e) => {document.querySelector("body").classList.remove("no-scroll")};

	//accordion Funcionality
	let acordionitems = document.querySelectorAll(".accordion-js .tab-js");
	acordionitems.forEach((item) => {
		item.addEventListener("click", (element) => {
			element.target.classList.toggle("active");
			element.target.nextElementSibling.classList.toggle("active");
		});
	});
})();